import React from 'react'

export const LabContext = React.createContext({
  labs: [],
  setLabs: () => {},
  selectedLab: '',
  setSelectedLab: () => {},
  accounts: [],
  setAccounts: () => {},
  selectedAccount: null,
  setSelectedAccount: () => {},
  isSuperCoordinator: false,
  setIsSuperCoordinator: () => {}
})
